import React, { useEffect, useRef, useState } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import planningService from "@services/planning.service";


function PSshare() {
  const [data, setData] = useState([{ name: "Loading ......" }]);
  const [dataUpdate, setDataUpdate] = useState([{ name: "Loading ......" }]);
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    let isMounted = true;
    setBlocked(true);
    planningService.fetchDashboard().then((result) => {
      if (isMounted) {
        setBlocked(false);
        setData(result.data);
      }
    });
    planningService.fetchDashboardUpdate().then((result) => {
      if (isMounted) {
        setBlocked(false);
        setDataUpdate(result.data);
      }
    });
    return () => { isMounted = false };
  }, []);



  return (
    <div>
       <div className="card">
      <Fieldset legend="Summry">
        <DataTable loading={blocked} size="small" value={data} tableStyle={{ minWidth: '50rem' }}>
          {Object.keys(data[0]).map((col, i) => (
            <Column key={col} field={col} header={col} />
          ))}
        </DataTable>
      </Fieldset>
      <Fieldset legend="Update">
        <DataTable loading={blocked}  size="small"  value={dataUpdate} tableStyle={{ minWidth: '50rem' }}>
          {Object.keys(dataUpdate[0]).map((col, i) => (
            <Column key={col}  field={col} header={col} />
          ))}
        </DataTable>
      </Fieldset>
</div>
    </div>
  );
}

export default PSshare;




